import * as ActionType from "./verification.type";

const initialState = {
    requests: [],
};

export const verificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionType.GET_VERIFICATION_REQUESTS:
            return {
                ...state,
                requests: action.payload,
            };
        case ActionType.UPDATE_VERIFICATION_STATUS:
            return {
                ...state,
                requests: state.requests.map((request) =>
                    request._id === action.payload._id ? action.payload : request
                ),
            };
        case ActionType.DELETE_VERIFICATION_REQUEST:
            return {
                ...state,
                requests: state.requests.filter(
                    (request) => request._id !== action.payload
                ),
            };
        default:
            return state;
    }
};
